import styled, { css } from 'styled-components';
import theme from '|/components/base/theme';
import ArrowForward from '|/icons/arrow-forward.svg';

export const modalContentStyles = css`
  @media (min-width: ${theme.breakpoints.md}) {
    max-width: 514px;
  }
`;

export const Container = styled.a`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  padding: 28px 30px;
  position: relative;

  @media (min-width: ${theme.breakpoints.md}) {
    cursor: pointer;
  }
`;

const imageSize = '65px';

export const ImageContainer = styled.div`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: ${imageSize};
  justify-content: center;
  margin-right: 16px;
  overflow: hidden;
  width: ${imageSize};
`;

export const Image = styled.img`
  height: 100%;
  transform: translate(10px, 0) scale(1.3);
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--colors-primary-blue-6);
  max-width: 168px;
  gap: 4px;

  @media (min-width: ${theme.breakpoints.xl}) {
    max-width: 180px;
  }
`;

const Text = styled.p`
  display: block;
  font-size: 14px;
`;

export const YearMakeModelText = styled(Text)`
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  margin: 0;
`;

export const TrimText = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const VdpLink = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: var(--colors-primary-blue-2);
  margin: 0;
`;

export const NavTabArrow = styled(ArrowForward)`
  display: none;
  margin-left: auto;

  @media (min-width: ${theme.breakpoints.md}) {
    display: initial;
  }

  height: 14px;
  width: 10px;

  & > g {
    fill: var(--colors-neutral-gray-3);
  }
`;
